import React from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { firestore, functions } from '../../helpers/Firebase';
import { Colxx } from "./CustomBootstrap";

const UpdateEmailModal = ({ 
  selected,
  isOpen, 
  toggle, 
  changeEmail, 
  setChangeEmail, 
  updatedProvider,
  onEmailUpdated 
}) => {
  const handleEmailChange = () => {
    const changeProviderEmail = functions().httpsCallable('updateRecords');
    changeProviderEmail({ 
      uid: updatedProvider?.key, 
      prop: { email: changeEmail.value } 
    }).then(function (result) {
      if (!result?.data?.error) {
        firestore().collection(selected).doc(updatedProvider?.key).update({
          email: changeEmail.value,
          updated: Date.now()
        }).then(() => {
          if (onEmailUpdated) {
            onEmailUpdated(changeEmail.value);
          }
          toggle(false);
        });
      }
    });
  };

  return (
    <Modal isOpen={isOpen} backdrop="static">
      <ModalHeader>
        Change Email
      </ModalHeader>
      <ModalBody>
        <Row>
          <Colxx xxs="12">
            <Label>
              New Email
            </Label>
            <Input
              type="text"
              value={changeEmail.value || ''}
              onChange={(e) =>
                setChangeEmail({ ...changeEmail, value: e.target.value })
              }
            />
          </Colxx>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={() => toggle(false)}>
          Cancel
        </Button>
        <Button color="primary" className="top-right-button" onClick={handleEmailChange}>
          Change
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateEmailModal;
